/**
 * CUSTOMIZATIONS:
 * - Nascosto il nome del sito padre se il sito è il portale RER (showHeaderBrand)
 *
 * HeaderSlim component.
 * @module components/ItaliaTheme/Header/HeaderSlim
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { HeaderSlimRightZone } from 'design-comuni-plone-theme/components/ItaliaTheme';
import {
  Header,
  HeaderBrand,
  HeaderContent,
  HeaderRightZone,
} from 'design-react-kit';
import { useIntl } from 'react-intl';
import {
  getSiteProperty,
  useHomePath,
} from 'design-comuni-plone-theme/helpers';
import { SiteProperty } from 'volto-site-settings';

const HeaderSlim = () => {
  const subsite = useSelector((state) => state.subsite?.data);
  const intl = useIntl();
  const homepath = useHomePath();
  let parentSiteURL = subsite
    ? homepath
    : getSiteProperty('parentSiteURL', intl.locale);

  const staticParentSiteTitle = getSiteProperty('parentSiteTitle', intl.locale);

  const parentSiteTitle = SiteProperty({
    property: 'site_title',
    forceValue: subsite ? null : staticParentSiteTitle,
    defaultValue: staticParentSiteTitle,
    getValue: true,
    getParent: true,
  });

  let isRERPortal =
    process.env.RAZZLE_IS_RER_PORTAL ||
    (__CLIENT__ && window?.env.RAZZLE_IS_RER_PORTAL);
  isRERPortal = isRERPortal == true || isRERPortal === 'true';

  const showHeaderBrand = !(isRERPortal && !subsite);

  const target = subsite ? null : '_blank';
  return (
    <Header small={false} theme="" type="slim" role="navigation">
      <HeaderContent>
        {showHeaderBrand && (
          <HeaderBrand
            responsive
            href={parentSiteURL}
            target={target}
            rel="noopener noreferrer"
          >
            {parentSiteTitle}
          </HeaderBrand>
        )}
        <HeaderRightZone>
          <HeaderSlimRightZone />
        </HeaderRightZone>
      </HeaderContent>
    </Header>
  );
};

export default HeaderSlim;
